import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';

// Firebase configuration for frontend
// These are public-facing credentials, safe to expose
// Security is enforced through Firestore rules
const firebaseConfig = {
  apiKey: "AIzaSyBIfRNJa3Fq7uuLZta0aS_Q2h_kKsx03RE",
  authDomain: "marathon-36b34.firebaseapp.com",
  projectId: "marathon-36b34",
  storageBucket: "marathon-36b34.firebasestorage.app",
  messagingSenderId: "891068854669",
  appId: "1:891068854669:web:abc123def456" // You'll need to get this from Firebase Console
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with persistence
const db = getFirestore(app);

// Enable offline persistence and caching
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    console.warn('The current browser does not support persistence.');
  }
});

export { db };
